export default function RedirectHelper(error: any): void {
  if (error?.status === 401) {
    window.location.href = "/login";
  }
}
